module.exports = __webpack_public_path__ + "static/media/400051_01.56c103c9.png";